<template>
  <router-view v-if="$route.name.includes('Show')"/>
  <div v-else class="d-grid grid-col-1 grid-col-lg-1-2 gap-6">
    <div>
      <v-card class="shadow pa-5">
        <template v-if="statistic.length">
          <BaseWidget :items="statistic" circular class="mb-5"/>
          <BaseWidget :items="statistic"/>
        </template>
        <Plug v-else/>
      </v-card>
    </div>
    <TemplatePageGrid
      :items="employeeSalaryReportGrid?.grid?.data || []"
      :page-data="employeeSalaryReportGrid?.grid || {}"
    >
      <template slot="buttons">
        <BaseInput
          type="autocomplete"
          minimize multiple small-chips
          :label="localStorage.translations.pages.finance['invoice-table'].client"
          :items="filter.client"
          v-model="selected.client"
          placeholder="—"
          class="max-width"
        />
        <BaseInput
          type="autocomplete"
          minimize multiple small-chips
          :label="localStorage.translations.pages.finance['invoice-table'].project"
          :items="filter.project"
          v-model="selected.project"
          placeholder="—"
          class="max-width"
        />
        <BaseInput
          type="autocomplete"
          minimize multiple small-chips
          :label="localStorage.translations.pages.finance['invoice-table'].weeks"
          :items="filter.week"
          v-model="selected.week"
          placeholder="—"
          class="max-width"
        />
        <BaseInput
          type="autocomplete"
          minimize multiple small-chips
          :label="localStorage.translations.pages.finance['salary-table'].status"
          :items="filter.status"
          v-model="selected.status"
          item-value="status"
          placeholder="—"
          class="max-width"
        />
      </template>
      <BaseTableView :head="tableHead" list-view="lgAndUp">
        <FinanceSalaryListTableItem
          v-for="(item, i) in employeeSalaryReportGrid?.grid?.data || []"
          :key="i"
          :item="item"
        />
      </BaseTableView>
    </TemplatePageGrid>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Plug from "components/Plug";
import FinanceSalaryListTableItem from "components/finance/salary/FinanceSalaryListTableItem";

export default {
  name: "salaryList",
  components: {FinanceSalaryListTableItem, Plug},
  computed: {
    ...mapGetters('employeeSalaryReport', ['employeeSalaryReportGrid']),
    tableHead() {
      return [
        {text: this.localStorage.translations.pages.finance['period-table'].employee},
        {text: this.localStorage.translations.pages.finance['invoice-table']['project']},
        {text: this.localStorage.translations.pages.finance['invoice-table']['weeks']},
        {text: this.localStorage.translations.pages.finance['invoice-table']['report']},
        {text: this.localStorage.translations.pages.finance['salary-table']['status']},
        {text: '', active: true},
      ]
    },
    statistic() {
      let result = []
      let arr = ['new', 'in_progress', 'done']
      if (this.employeeSalaryReportGrid.statistic && this.employeeSalaryReportGrid.statistic.statuses) {
        for (let i in arr) {
          switch (arr[i]) {
            case 'new':
              if (this.employeeSalaryReportGrid.statistic.statuses['new']['count'] > 0)
                result.push({
                  color: '#277FAF',
                  name: this.localStorage.translations.pages.finance['invoice-status']['created'],
                  count: this.employeeSalaryReportGrid.statistic.statuses['new']['count']
                })
            case 'done':
              if (this.employeeSalaryReportGrid.statistic.statuses['done']['count'] > 0)
                result.push({
                  color: '#038800',
                  name: this.localStorage.translations.pages.finance['invoice-status']['paid'],
                  count: this.employeeSalaryReportGrid.statistic.statuses['done']['count']
                })
            default:
              if (this.employeeSalaryReportGrid.statistic.statuses['in_progress']['count'] > 0)
                result.push({
                  color: '#F2C94C',
                  name: this.localStorage.translations.pages.finance['invoice-status']['part_paid'],
                  count: this.employeeSalaryReportGrid.statistic.statuses['in_progress']['count']
                })
          }
        }
      }
      return result
    },
    filter() {
      let result = {
        client: [],
        project: [],
        week: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52],
        status: [
          {
            status: 'new',
            name: this.localStorage.translations.pages.finance['invoice-status']['created'],
          },
          {
            status: 'in_progress',
            name: this.localStorage.translations.pages.finance['invoice-status']['part_paid'],
          },
          {
            status: 'done',
            name: this.localStorage.translations.pages.finance['invoice-status']['paid'],
          },
        ]
      }
      for (let i in this.employeeSalaryReportGrid.filter.clients) {
        result.client.push({
          id: i,
          name: this.employeeSalaryReportGrid.filter.clients[i].name
        })
        for (let p in this.employeeSalaryReportGrid.filter.clients[i].projects) {
          result.project.push({
            id: p,
            name: this.employeeSalaryReportGrid.filter.clients[i].projects[p]
          })
        }
      }
      
      /*this.workClientProjectsClientBillStatuses.forEach(element => {
          result.status.push({
            name: this.localStorage.translations.pages.finance['invoice-status'][element.translation],
            status: element.status,
          })
        }
      )*/
      return result
    }
  },
  data: () => ({
    selected: {
      client: [],
      project: [],
      week: [],
      status: []
    }
  }),
  watch: {
    '$route.query'() {
      this.getPageData()
    },
    'selected.client'() {
      this.getPageData()
    },
    'selected.project'() {
      this.getPageData()
    },
    'selected.week'() {
      this.getPageData()
    },
    'selected.status'() {
      this.getPageData()
    },
  },
  mounted() {
    this.getPageData()
  },
  methods: {
    ...mapActions('employeeSalaryReport', ['onEmployeeSalaryReportGrid']),
    getPageData() {
      if (!this.$route.name.includes('Show'))
        this.onEmployeeSalaryReportGrid({
          limit: this.$route.query.limit,
          page: this.$route.query.page,
          client: this.selected.client.join(','),
          project: this.selected.project.join(','),
          week: this.selected.week.join(','),
          status: this.selected.status.join(','),
        })
    },
  },
}
</script>

<style scoped lang="scss">
.shadow {
  box-shadow: 0 4px 4px rgba(133, 133, 133, 0.25) !important;
  border-radius: 10px;
}
</style>
